import FavoriteBtn from 'components/Common/ActionButton/FavoriteBtn';
import { S3_URL, USER_TYPES } from 'constants';
import { IMAGE_PATHS } from 'constants/imagePaths';
import { useEffect, useState } from 'react';
import { Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useAuthStore from 'store/auth';
import { setModalConfig } from 'store/common';
import { getCreatedDifferenceInBestUnit, unitNumber } from 'utils';

const JobCard: React.FC<any> = ({ job }) => {
	const navigate = useNavigate();
	const authUser: any = useAuthStore((state) => state.userInfo.user);
	const [isFavourite, setIsFavourite] = useState<boolean>(false);

	useEffect(() => {
		setIsFavourite(job?.isFavourite || false);
	}, [job]);

	const onCardClick = () => {
		navigate(`/job-detail/${job?.jobId}`);
	};

	const handleClick = (id: number | null = null) => {
		if (!authUser?.userId) {
			setModalConfig({
				visible: true,
				id: id,
				type: 'loginModal',
			});
			return false;
		}
		return true;
	};

	return (
		<div className="job-card" onClick={onCardClick}>
			<div className="job-card-top d-flex justify-content-between gap-3">
				<div className="job-card-logo">
					<Image
						className="w-100 h-100 object-fit-cover"
						src={job?.companyLogo ? `${S3_URL}${job.companyLogo}` : IMAGE_PATHS.CompanyLogoDefault}
						alt="job-logo"
						loading="lazy"
					/>
				</div>
				{(!authUser?.userType || authUser?.userType !== USER_TYPES?.COMPANY) && (
					<FavoriteBtn
						isFavourite={isFavourite}
						setIsFavourite={setIsFavourite}
						jobId={Number(job?.jobId)}
						handleClick={handleClick}
						className="whishlist-btn bg-white rounded-circle p-0"
					/>
				)}
			</div>
			<div className="job-card-content">
				<h6>{job?.companyName}</h6>
				<h3 className="fw-bold mb-0">
					{job?.title.length > 50 ? job?.title.slice(0, 50) + '...' : job?.title}
				</h3>
				<div className="job-info d-flex flex-column flex-xl-row align-items-xl-center gap-2 gap-xl-3">
					{job?.level?.[0]?.title && (
						<div className="d-flex align-items-center gap-2">
							<i className="ri-award-line job-info-icon"></i>
							<h5 className="mb-0 fw-semibold">{job.level[0]?.title}yrs</h5>
						</div>
					)}
					<div className="d-flex align-items-center gap-2">
						<i className="ri-wallet-2-line job-info-icon"></i>
						<h5 className="mb-0 fw-semibold">
							{job?.currency}
							{[unitNumber(job?.minAmount, 1), unitNumber(job?.maxAmount, 1)]
								.filter(Boolean)
								.join('-') ?? ''}
							{job?.salaryType && <span>({job?.salaryType})</span>}
						</h5>
					</div>
				</div>
				{job?.createdAt && <p className="mb-0">{getCreatedDifferenceInBestUnit(job.createdAt)}</p>}
			</div>
		</div>
	);
};

export default JobCard;
